export const data1 = {
	"listMa": [{
			"entity": {
				"id": 9,
				"parentMenuId": 0,
				"name": "诊所管理",
				"alias": "诊所管理",
				"state": "ENABLE",
				"sort": 0,
				"value": null,
				"type": "NONE",
				"createUserId": 5,
				"iconImg": "c3"

			},
			"childs": [{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "addClinic",
					"alias": "添加诊所",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/addClinic",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			}, {
				"entity": {
					"id": 11,
					"parentMenuId": 1,
					"name": "clinicProbate",
					"alias": "诊所认证",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/clinicProbate",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			},{
				"entity": {
					"id": 11,
					"parentMenuId": 1,
					"name": "clinicManagement",
					"alias": "诊所管理",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/clinicManagement",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			}]
		},
		{
			"entity": {
				"id": 9,
				"parentMenuId": 0,
				"name": "用户管理",
				"alias": "用户管理",
				"state": "ENABLE",
				"sort": 0,
				"value": null,
				"type": "NONE",
				"createUserId": 5,
				"iconImg": "c3"

			},
			"childs": [{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "doctorProbate",
					"alias": "医护人员认证",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/doctorProbate",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			},
			{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "doctorList",
					"alias": "医护人员管理",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/doctorList",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			},{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "doctorExpert",
					"alias": "专家团队管理",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/doctorExpert",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			}]
			},
			{
			"entity": {
				"id": 9,
				"parentMenuId": 0,
				"name": "数据分析",
				"alias": "数据分析",
				"state": "ENABLE",
				"sort": 0,
				"value": null,
				"type": "NONE",
				"createUserId": 5,
				"iconImg": "c3"

			},
			"childs": [{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "userOverview",
					"alias": "用户总览",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/userOverview",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			},
			{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "desktopExe",
					"alias": "桌面软件",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/desktopExe",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			},
			{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "vCard",
					"alias": "医患通",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/vCard",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			}]
		},
		{
			"entity": {
				"id": 9,
				"parentMenuId": 0,
				"name": "运营管理",
				"alias": "运营管理",
				"state": "ENABLE",
				"sort": 0,
				"value": null,
				"type": "NONE",
				"createUserId": 5,
				"iconImg": "c3"

			},
			"childs": [{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "doctorProbate",
					"alias": "优惠券",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/coupon",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			},{
				"entity": {
					"id": 10,
					"parentMenuId": 1,
					"name": "sharingCommunity",
					"alias": "分享社区管理",
					"state": "ENABLE",
					"sort": 0,
					"value": "/indexMa/sharingCommunity",
					"type": "LINK",
					"createUserId": 5
				},
				"childs": null
			}]
			},
	]

}


// WEBPACK FOOTER //
// ./src/assets/js/leftData.js